import crimeIcon from "../assets/imgs/layout/crimes.png";
import travelIcon from "../assets/imgs/layout/location.png";
import gameIcon from "../assets/imgs/layout/game.png";
import miscIcon from "../assets/imgs/layout/misc.png";
import config from "../config/config";

export const SideNavLinks = [
  {
    category: "CRIMES",
    icon: crimeIcon,

    subLinks: [
      {
        name: "Crimes",
        link: "/crimes",
        showCooldown: true,
      },
      {
        name: "Nick a car",
        link: "/nickcar",
        showCooldown: true,
      },
      {
        name: "Travel",
        link: "/travel",
        showCooldown: true,
      },
      {
        name: "Jail",
        link: "/jail",
        showCooldown: true,
      },
      {
        name: "Kill skill",
        link: "/killskill",
        showCooldown: true,
      },
      {
        name: "Helper bots",
        link: "/helper",
        showCooldown: false,
      },
    ],
  },
  {
    category: "LOCATION",
    icon: travelIcon,
    subLinks: [
      {
        name: "City map",
        link: "/map",
      },
      {
        name: "Booze",
        link: "/booze",
        showCooldown: true,
      },
      {
        name: "Narcotics",
        link: "/narcotics",
        showCooldown: true,
      },
      {
        name: "Roulette",
        link: "/roulette",
      },
      {
        name: "Slotmachine",
        link: "/slotmachine",
      },
      {
        name: "Garage",
        link: "/garage",
      },
      {
        name: "Bullet Factory",
        link: "/bullet/factory",
        showCooldown: true,
      },
      {
        name: "Bank",
        link: "/bank",
        showCooldown: true,
      },
    ],
  },
  {
    category: "GAME",
    icon: gameIcon,
    subLinks: [
      {
        name: "My profile",
        link: "/profile",
      },
      {
        name: "Family",
        link: "/family",
      },
      {
        name: "Marketplace",
        link: "/market",
      },
      {
        name: "Crates",
        link: "/crate",
      },
      {
        name: "The Exchange",
        link: "/exchange",
      },
      {
        name: "Players & Families",
        link: "/family",
      },
    ],
  },
  {
    category: "MISC",
    icon: miscIcon,
    subLinks: [
      {
        name: "Vault",
        link: "/vault",
      },
      {
        name: "Buy $MAFIA",
        link: "/buy",
      },
      {
        name: "Marketing DAO",
        link: "/dao",
      },
      {
        name: "Game wiki",
        link: config.gitbookUrl,
        target: "_blank",
      },
    ],
  },
];
